<template>
  <vmodal ref="allModulesModal" name="allModulesModal" height="auto" width="1100" class="allModulesModal">
    <div class="modules-modal-wrapper">
      <!-- CLOSE -->
      <div class="close-modal" @click="closeModulesModal">✕</div>

      <!-- LEFT -->
      <div class="modules-left">
        <div>
          <h2>{{ $t('general.ecosystem') }}</h2>
          <p>{{ $t('general.ecosystem_more_than_you_use') }}</p>
        </div>
        <img src="../../../../static/img/modules-girl.png" class="girl-image" />
      </div>

      <!-- RIGHT -->
      <div
        ref="scrollContainer"
        class="modules-right"
        @wheel.prevent="onWheel"
        @mouseenter="onMouseEnter"
        @mouseleave="onMouseLeave"
      >
        <!-- PROGRESS -->
        <div class="progress-wrapper">
          <p class="progress-title">{{ $t('general.how_much_you_use') }}</p>
          <div class="progress-bar-area">
            <span class="progress-badge">{{ activeModulesPercent }}%</span>
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: activeModulesPercent + '%' }"></div>
            </div>
          </div>
          <div class="progress-labels">
            <span>{{ $t('general.only_this_much_you_use') }}</span>
            <span>{{ $t('general.you_use_full_system') }}</span>
          </div>
        </div>

        <!-- TITLE -->
        <div class="modules-title">{{ $t('general.all_taptasty_modules') }}</div>

        <!-- ACTIVE -->
        <div class="modules-group-title">{{ $t('general.modules_active') }}</div>
        <div class="modules-grid">
          <div v-for="module in activeModules" :key="module.key" class="module-card active">
            <div class="module-icon">
              <img :src="module.image" :alt="module.key">
            </div>
            <div class="module-name">{{ $t(`general.${module.name}`) }}</div>
            <div class="module-check active">✓</div>
          </div>
        </div>

        <!-- INACTIVE -->
        <div class="modules-group-title inactive-title">{{ $t('general.modules_inactive_hint') }}</div>
        <div class="modules-grid">
          <div v-for="module in inactiveModules" :key="module.key" class="module-card inactive">
            <div class="module-icon">
              <img :src="module.image" :alt="module.key">
            </div>
            <div class="module-name">{{ $t(`general.${module.name}`) }}</div>
            <div class="module-check">✓</div>
          </div>
        </div>
      </div>
    </div>
  </vmodal>
</template>

<script>
export default {
  name: 'AllModulesModal',
  props: {
    activeModulesPercent: {
      type: Number,
      default: 0
    },
    activeModules: {
      type: Array,
      default: () => []
    },
    inactiveModules: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      scrollSpeed: 1.2,
      isHovering: false
    }
  },
  methods: {
    open () {
      this.$modal.show('allModulesModal')
      this.$nextTick(() => {
        this.resetScroll()
      })
    },
    close () {
      this.$modal.hide('allModulesModal')
    },
    closeModulesModal () {
      this.$modal.hide('allModulesModal')
    },
    resetScroll () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollTop = 0
      }
    },
    onMouseEnter () {
      this.isHovering = true
    },
    onMouseLeave () {
      this.isHovering = false
    },
    onWheel (event) {
      if (!this.$refs.scrollContainer) return

      const container = this.$refs.scrollContainer
      const delta = event.deltaY || event.detail || 0
      const scrollAmount = delta * this.scrollSpeed

      // Verificăm dacă am ajuns la capăt
      const isAtTop = container.scrollTop <= 0 && delta < 0
      const isAtBottom =
        container.scrollTop + container.clientHeight >= container.scrollHeight - 1 &&
        delta > 0

      // Dacă nu suntem la capăt, facem scroll manual
      if (!isAtTop && !isAtBottom) {
        container.scrollTop += scrollAmount
      } else if (isAtTop && delta < 0) {
        container.scrollTop = 0
      } else if (isAtBottom && delta > 0) {
        container.scrollTop = container.scrollHeight - container.clientHeight
      }
    }
  }
}
</script>

<style scoped>
.allModulesModal::v-deep .vm--overlay {
  background: rgba(18, 0, 48, 0.78) !important;
  backdrop-filter: blur(2px);
}

.allModulesModal::v-deep .vm--modal {
  overflow: visible !important;
  background: transparent !important;
  border-radius: 36px !important;
  box-shadow: none !important;
}
/* MAIN */
.modules-modal-wrapper {
  position: relative;
  width: 100%;
  height: 75vh;
  display: flex;
  overflow: hidden;
  border-radius: 36px;
  border: 8px solid #f4f3ff;
  background: #2E0477;
  box-shadow: 0 30px 80px rgba(0,0,0,0.45), inset 0 1px 0 rgba(255,255,255,0.08);
}

/* CLOSE */
.close-modal {
  position: absolute;
  top: 11px;
  right: 13px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #ffffff;
  border: 2px solid rgba(255,255,255,0.95);
  color: #4820a9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 5px 14px rgba(0,0,0,0.28);
  transition: 0.15s ease;
}

.close-modal:hover {
  transform: scale(1.05);
}

/* LEFT */
.modules-left {
  width: 260px;
  background: linear-gradient(180deg, #2ed1b2 0%, #56c48f 58%, #c9a33d 100%);
  padding: 46px 18px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  border-top-right-radius: 36px;
}

.modules-left h2 {
  margin: 0;
  color: #ffffff;
  text-align: center;
  font-size: 28px;
  line-height: 1.14;
  font-weight: 900;
  text-transform: uppercase;
}

.modules-left p {
  margin: 16px 0 0;
  color: #fff;
  text-align: center;
  font-size: 14px;
  line-height: 1.45;
  font-weight: 400;
}

.girl-image {
  width: 127%;
  margin-left: -11px;
  margin-bottom: -2px;
  object-fit: contain;
  pointer-events: none;
  user-select: none;
}

/* RIGHT - scroll controlat din JS */
.modules-right {
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden; /* ascundem scrollbar-ul nativ */
  padding: 32px 56px 28px;
  overscroll-behavior: contain;
  cursor: default;
}

/* PROGRESS */
.progress-wrapper {
  width: 100%;
  margin: 0 auto 15px;
}

.progress-title {
  margin: 0 0 16px;
  color: #ffffff;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
}

/* BAR */
.progress-bar-area {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 45px;
  background: #3C118F;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border-top-left-radius: 60px;
  border-top-right-radius: 60px;
}

.progress-bar-area::before,
.progress-bar-area::after {
  content: "";
  width: 34px;
  height: 34px;
  min-width: 34px;
  border-radius: 50%;
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.92);
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-bar-area::before {
  background-image: url("../../../../static/img/smile-beam.png");
}

.progress-bar-area::after {
  background-image: url("../../../../static/img/grin-beam.png");
}

.progress-badge {
  min-width: 44px;
  height: 22px;
  padding: 0 10px;
  border-radius: 999px;
  background: #ffb700;
  color: #2E0477;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.15), 0 2px 8px rgba(255, 183, 0, 0.45);
}

.progress-bar {
  flex: 1;
  height: 25px;
  border-radius: 999px;
  background: rgba(0,0,0,0.2);
  overflow: hidden;
  position: relative;
}

.progress-fill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #ffae00 0%, #ffc400 100%);
  box-shadow: 0 0 14px rgba(255,196,0,0.55);
}

.progress-labels {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  position: relative;
  bottom: 22px;
}

.progress-labels span {
  padding: 6px 18px;
  border-radius: 999px;
  background: rgba(136, 98, 255, 0.55);
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
}

/* TITLE */
.modules-title {
  margin-bottom: 0px;
  color: #ffffff;
  text-align: center;
  font-size: 22px;
  font-weight: 400;
  letter-spacing: -0.2px;
}

/* GRID */
.modules-grid {
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
}

/* CARD */
.module-card {
  gap: 20px;
  position: relative;
  height: 134px;
  border-radius: 25px;
  background: linear-gradient(180deg, rgba(126, 87, 255, 0.95) 0%, rgba(90, 38, 207, 0.95) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: 0.16s ease;
  cursor: pointer;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.08), 0 10px 18px rgba(0,0,0,0.12);
}

.module-card:hover {
  transform: translateY(-2px);
}

.module-card.active {
  background: linear-gradient(180deg, rgba(126, 87, 255, 0.95) 0%, rgba(90, 38, 207, 0.95) 100%);
  opacity: 1;
}

.module-card.inactive {
  opacity: 0.52;
  background: #3B118E;
}

/* ICON */
.module-icon {
  margin-bottom: 0px;
}

.module-icon img {
  width: 34px;
  height: 34px;
  object-fit: contain;
}

/* TEXT */
.module-name {
  max-width: 85px;
  color: #ffffff;
  text-align: center;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 400;
}

/* CHECK */
.module-check {
  position: absolute;
  bottom: -13px;
  left: 50%;
  transform: translateX(-50%);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #2b1360;
  border: 3px solid #35107f;
  color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 900;
}

.module-check.active {
  background: #25d6b3;
  border-color: #25d6b3;
  color: #ffffff;
  box-shadow: 0 0 14px rgba(37,214,179,0.58);
}

/* GROUP TITLES */
.modules-group-title {
  color: #fff;
  margin-bottom: 10px;
}

.modules-group-title.inactive-title {
  margin-top: 40px;
}

/* RESPONSIVE */
@media (max-width: 1500px) {
  .progress-wrapper {
    margin: 0 auto 14px;
  }
}

@media (max-width: 991px) {
  .allModulesModal::v-deep .vm--modal {
    width: calc(100vw - 20px) !important;
    left: 10px !important;
    margin-left: 0 !important;
  }

  .modules-modal-wrapper {
    flex-direction: column;
    min-height: auto;
  }

  .modules-left {
    width: 100%;
  }

  .girl-image {
    width: 260px;
    margin: 30px auto 0;
  }

  .modules-right {
    padding: 30px 20px 40px;
    overflow-y: auto; /* pe mobil lăsăm scroll nativ */
  }

  .modules-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/AllModulesModal.vue